import {assessAuthorTypes} from '../settingsTypes';

const initialState = {
    allAssessmentAuthors: [],
    loading: false,
    error: '',
    text: '',
    author:'',
    totalAuthorsCount: 0,
    allAuthors:[],
    errorauthordelete:false,
    loadingauthordelete:false,
    successauthorupdate: false,
    loadingauthorupdate: false,
    errorauthorupdate:false,
    successauthordelete:false,
    errorauthorcreate: '',
    successauthorcreate: false,
}

export function authorReducer(state = initialState, action){
    switch (action.type){
        case assessAuthorTypes.CREATE_PAGE_REFRESH:
            return {
                ...state,
                allAssessmentAuthors: [],
                loading: false,
                error: '',
                text: '',
                author:'',
                totalAuthorsCount:0,
                allAuthors:[],
                errorauthordelete:false,
                loadingauthordelete:false,
                successauthorupdate: false,
                loadingauthorupdate: false,
                errorauthorupdate:false,
                successauthordelete:false,
                errorauthorcreate: '',
                successauthorcreate: false,
            }
        //Author retrieve request sending
        case assessAuthorTypes.GET_ALL_ASSESSMENT_AUTHORS:
            return {
                ...state,
                loading: true,
                text: 'Get all the assessment authors'
            }
        case assessAuthorTypes.GET_ALL_ASSESSMENT_AUTHORS_REQUEST:
            return {
                ...state,
                loading: true
            }
        case assessAuthorTypes.GET_ALL_ASSESSMENT_AUTHORS_SUCCESS:
            return {
                ...state,
                loading: false,
                allAssessmentAuthors: action.authors.authors,
                totalAuthorsCount: action.authors.total_count
            }
        case assessAuthorTypes.GET_ALL_ASSESSMENT_AUTHORS_FAILURE:
            return {
                ...state,
                error: action.error,
                loading: false
            }
        //Author creation request sending
        case assessAuthorTypes.CREATE_AUTHOR_REQUEST:
            return {
                ...state,
                errorauthorcreate: '',
                successauthorcreate: false,
                loading: true
            }
        case assessAuthorTypes.CREATE_AUTHOR_SUCCESS:
            var temp = state.allAuthors;
            temp.push(action.authors)
            return {
                ...state,
                allAuthors: temp,
                author: action.authors.author_id,
                successauthorcreate: true,
                loading: false
            }
        case assessAuthorTypes.CREATE_AUTHOR_FAILURE:
            return {
                ...state,
                errorauthorcreate: action.error,
                loading: false
            }  
        //Author deletion request sending   
        case assessAuthorTypes.DELETE_AUTHOR_REQUEST:
            return {
            ...state,
            errorauthordelete: '',
            successauthordelete: false,
            loading: true,
            };
        case assessAuthorTypes.DELETE_AUTHOR_SUCCESS:
            return {
            ...state,
            successauthordelete: true,
            loading: false,
            };
        case assessAuthorTypes.DELETE_AUTHOR_FAILURE:
            return {
            ...state,
            errorauthordelete: action.error,
            loading: false,
            };
        //Author updation request sending
        case assessAuthorTypes.UPDATE_AUTHOR_REQUEST:
            return {
            ...state,
            errorauthorupdate:'',
            successauthorupdate: false,
            loading: true,
            };
        case assessAuthorTypes.UPDATE_AUTHOR_SUCCESS:
            return {
            ...state,
            successauthorupdate: true,
            loading: false,
            };
        case assessAuthorTypes.UPDATE_AUTHOR_FAILURE:
            return {
            ...state,
            errorauthorupdate: action.error,
            loading: false,
            };     
        default:
            return state
    }
}
